export default [
  {
    id: 'regular_players',
    name: 'Regular Players',
  },
  {
    id: 'match_fee',
    name: 'Match Fee',
  },
  {
    id: 'fill_in_players',
    name: 'Fill-in Players',
  },
];
